/* eslint-disable react/no-array-index-key */
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { Touchpoint } from '../../../../../../api/services/mediaPlanning/touchpoints';

interface MissingMandatoryTouchpointTooltipProps {
  missingTouchpoints: Touchpoint[];
  country: string;
}

function MissingMandatoryTouchpointTooltip({
  missingTouchpoints,
  country,
}: MissingMandatoryTouchpointTooltipProps) {
  return (
    <Tooltip
      placement="right-end"
      title={
        <Box sx={{ backgroundColor: 'common.white', p: 3, borderRadius: 1 }}>
          <Typography variant="body2" fontSize="16px" color="red" mb={2}>
            Missing mandatory touchpoints:{' '}
          </Typography>
          {missingTouchpoints?.map((tp, idx) => (
            <Typography
              key={`${tp.TouchpointName}-${idx}`}
              variant="body2"
              color="text.primary"
            >
              • {tp.TouchpointName} – {tp.touchpointFunnel}
            </Typography>
          ))}
          <Typography variant="body2" fontSize="12px" color="red" mt={2}>
            The plan cannot be saved
          </Typography>
        </Box>
      }
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'common.white',
            color: 'text.primary',
            boxShadow: 3,
            maxWidth: 300,
          },
        },
      }}
    >
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{ position: 'relative' }}
      >
        <Typography variant="body1" fontWeight={600}>
          {country}
        </Typography>
        <ErrorIcon
          color="warning"
          fontSize="small"
          sx={{ position: 'absolute', right: '-20px', top: '-6px' }}
        />
      </Stack>
    </Tooltip>
  );
}

export default MissingMandatoryTouchpointTooltip;
